import { lazy, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useLocalProjects } from '../../data/registry.ts';

// Only a first-time visitor ever loads this, and it carries the screenshots and the display font.
const LandingPage = lazy(() => import('../landing/LandingPage.tsx').then((m) => ({ default: m.LandingPage })));

/** Router state for `/`: a project to pass over because it was just deleted or can't be opened. */
export interface LaunchState {
  skip?: string;
}

/**
 * `/`: Tomo always opens a project; there is no project list page. It reopens the one used last,
 * and with none on this device (a first visit, or the last one was just deleted) it shows the
 * landing page, whose calls to action all lead to `/new`.
 *
 * The registry is loaded before the app renders (see `main.tsx`), so a returning visitor redirects
 * on the first render and never sees the landing page.
 */
export function Launch() {
  const projects = useLocalProjects(); // most recently opened first
  const { skip } = (useLocation().state ?? {}) as LaunchState;
  const next = projects.find((p) => p.id !== skip);
  if (next) return <Navigate to={`/p/${next.id}`} replace />;
  return (
    <Suspense fallback={null}>
      <LandingPage />
    </Suspense>
  );
}
